<template>
  <div class="app-client-area">
    <router-view></router-view>
    <ui-blocker></ui-blocker>
  </div>
</template>

<style lang="less">
.app-client-area{
  height:100%;
  width:100%;
  color:#fff;
  background-color:#000;
}
</style>

<script>
import axios from 'axios';
import _ from 'underscore';
import UIBlocker from './components/common/UIBlocker.vue'
import settings from './settings';
import globals from './globals';

export default {
  components:{   
      'ui-blocker':UIBlocker
  },
  data () {
    return {
      token:globals.getToken(),
      version:globals.version,
    }
  },
  computed:{
    loggedIn(){
      return this.$store.state.user!=undefined;
    },
    user(){
      return this.$store.state.user;
    }
  },
  mounted(){
    this.livemode=this.$route.query.livemode=="true";
    this.$root.$on('loggedIn',()=>{this.token=globals.getToken();});
  },
  watch: {},
  methods:{
  }
}
</script>

